/* ==========================================================================
   PanelVehicle > Ui
   ========================================================================== */

/* Modules */
const config = require('./config');

/* Shows wrapper extra */
const showExtra = wrapper => wrapper.classList.remove(config().css.hidden);

/* Hide wrapper extra */
const hideExtra = wrapper => wrapper.classList.add(config().css.hidden);

/* Shows option */
const displayOption = option => option.show();

/* Display extra options */
const displayOptions = options => options.forEach(item => displayOption(item));

/* Hides option */
const hideOption = option => option.hide();

/* Hide extra options */
const hideOptions = options => options.forEach(item => hideOption(item));

/* Hide all */
const hideAll = (instance, extraWrapper) => {
    /* Main options */
    hideOptions([instance.vehicle.height, instance.vehicle.length]);

    /* Extra */
    hideExtra(extraWrapper);
};

/* Update visibility of extra options */
function updateUi(instance) {
    if (!instance.vehicle.product) return false;

    const productValue = Number(instance.vehicle.product.get().value);
    const extraWrapper = instance.element.querySelector('[data-extra]');
    const extraIsChecked = instance.extra.toggle.isChecked();

    /* Extra options wrapper */
    if (productValue === 0) return hideAll(instance, extraWrapper);

    /* Main options */
    displayOptions([instance.vehicle.length, instance.vehicle.height]);

    /* Extra wrapper */
    showExtra(extraWrapper);

    /* Extra options */
    if (extraIsChecked) return displayOptions([instance.extra.length, instance.extra.height]);
    hideOptions([instance.extra.length, instance.extra.height]);

    return true;
}

module.exports = {
    updateUi
};
